import React from 'react';
import './ContactForm.css';
import dburl from '../../utils/dburl';

export default class Form extends React.Component{

  handleClickForm = (event) => {
    const target = event.target;
    const formInside = target.querySelectorAll("input, textarea");
    //clear all the inputs in the form
    formInside.forEach(dom => {
      if(dom.type !== "submit")
        dom.value = "";
    })
  }

  handleSubmitForm = (event) => {
     //animation after submit
    const target = event.target;
    const formInside = target.querySelectorAll("input, textarea");

    const mask = target.querySelector(".mask");
    mask.style.display = "block";

    let index = 0;
    const iv = setInterval(() => {
      formInside[index].style.transform = "translateY(-400px)";
      index++;

      if(index > 4) {
        clearInterval(iv);
      }
    }, 60);

    setTimeout(() => {
      const succesText = target.querySelector(".success-text");
      succesText.style.display = "block";
      succesText.style.animation = "appear 1.5s";

    }, 1600);
  }

  render() {
    return (
      <React.Fragment>
        <form
          className="contact-form"
          method="post"
          action={dburl+"contact"}
          target="avoidJump"
          onSubmit={(e)=> this.handleSubmitForm(e)}
        >
          <div className="mask">
            <div className="success-text">Sent Successfully!</div>
          </div>

          <input type="text" name="fullname" placeholder="Full name" required/>

          <input type="email" name="email" placeholder="Email address" required/>

          <input type="text" name="company" placeholder="Company"/>

          <textarea type="text" name="message" placeholder="Message"required/>  

          <input
            type="submit"
            value="Submit" 
            onClick={(e) => this.handleClickForm(e)}
          />        
        </form>
        <iframe title="avoid" id="avoidJump" name="avoidJump" style={{display:'none', zIndex:'-1000'}}></iframe>
      </React.Fragment>
      
    )
  }
}